import { Link } from "expo-router";
import React from "react";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";

export function SectionBokBokDatingAppTitle() {
  const userLocale = intl.locale;
  const datingAppLocale = userLocale === "en" ? "" : userLocale;

  return (
    <View style={{ maxWidth: 1320, marginHorizontal: "auto" }}>
      <Spacer extraLarge />
      <Spacer extraLarge />
      <Text weightExtraBold colorDark alignCenter style={{ fontSize: 32 }}>
        {intl.formatMessage({
          id: "YzUjCl",
          defaultMessage: "Looking for love?",
          description: "Title on BokBok dating app section",
        })}
      </Text>
      <Spacer extraLarge />
      <Text sizeLarge colorDark alignCenter>
        {intl.formatMessage(
          {
            defaultMessage: "Try the <underline>BokBok Dating App</underline>.",
            id: "Uf9aX0",
            description: "Promo text",
          },
          {
            underline(chunks) {
              return (
                <Link asChild href={`https://bokbok.io/${datingAppLocale}`}>
                  <Text
                    weightSemiBold
                    sizeLarge
                    colorTheme
                    style={{ textDecorationLine: "underline" }}
                  >
                    {chunks}
                  </Text>
                </Link>
              ) as any;
            },
          },
        )}
      </Text>
    </View>
  );
}
